__turbopack_context__.v({
  "Slide": "QuoteCarouselSection-module-scss-module__7LTgqq__Slide",
  "Swiper": "QuoteCarouselSection-module-scss-module__7LTgqq__Swiper",
});
